/* Draft Store V6 only: hide the sticky personalization preview while a mobile keyboard is open. */
(() => {
  if (window.__pzKeyboardStickyGuardV6) return;
  window.__pzKeyboardStickyGuardV6 = true;

  const BODY_CLASS = 'pz-personalization-keyboard-open';
  const TEE_CONTEXT = '#tee-artwork-form, #teeFormInputs, .tee-customization-form, .tee-campaign-form-wrapper, .tee-field';
  const vv = window.visualViewport || null;

  let baselineHeight = Math.round((vv && vv.height) || window.innerHeight || 0);
  let focusGraceUntil = 0;
  let stateRaf = 0;

  const style = document.createElement('style');
  style.id = 'pz-keyboard-sticky-guard-v6';
  style.textContent = `
    body.${BODY_CLASS} .grid__item.product__media-wrapper .tee-gallery-content,
    body.${BODY_CLASS} .sticky-gallery-mask,
    body.${BODY_CLASS} .gallery--close-button,
    body.${BODY_CLASS} .sticky-gallery-button,
    body.${BODY_CLASS} .pz-sticky-zoom-controls,
    body.${BODY_CLASS} #tee-gallery.pz-sticky-preview .tee-gallery,
    body.${BODY_CLASS} #tee-gallery.pz-sticky-preview .pz-preview-controls {
      display: none !important;
    }
  `;
  (document.head || document.documentElement).appendChild(style);

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
  const viewportHeight = () => Math.round((vv && vv.height) || window.innerHeight || 0);

  const isPersonalizationTextField = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (!element.closest(TEE_CONTEXT)) return false;

    if (element.matches('textarea')) {
      return !element.disabled && !element.readOnly;
    }

    if (element.matches('[contenteditable]:not([contenteditable="false"])')) {
      return true;
    }

    if (!(element instanceof HTMLInputElement) || element.disabled || element.readOnly) return false;

    const type = (element.type || 'text').toLowerCase();
    return ['text', 'search', 'email', 'tel', 'url', 'number', 'password'].includes(type);
  };

  const setSuppressed = (suppressed) => {
    if (!document.body) return;
    const wasSuppressed = document.body.classList.contains(BODY_CLASS);
    document.body.classList.toggle(BODY_CLASS, suppressed);

    if (wasSuppressed && !suppressed) {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('scroll'));
      });
    }
  };

  const syncState = () => {
    if (!document.body) return;

    const currentHeight = viewportHeight();
    const focused = isPersonalizationTextField(document.activeElement);

    if (!isMobile()) {
      setSuppressed(false);
      if (currentHeight) baselineHeight = Math.max(baselineHeight, currentHeight);
      return;
    }

    if (!focused) {
      focusGraceUntil = 0;
      setSuppressed(false);
      if (currentHeight) baselineHeight = Math.max(baselineHeight, currentHeight);
      return;
    }

    if (!baselineHeight && currentHeight) baselineHeight = currentHeight;

    const viewportLoss = Math.max(0, baselineHeight - currentHeight);
    const keyboardThreshold = Math.max(140, Math.round(baselineHeight * 0.18));
    const viewportSaysKeyboardOpen = Boolean(vv && viewportLoss > keyboardThreshold);
    const focusGraceActive = performance.now() < focusGraceUntil;

    const shouldSuppress = viewportSaysKeyboardOpen || focusGraceActive || !vv;
    setSuppressed(shouldSuppress);

    if (!shouldSuppress && currentHeight) {
      baselineHeight = Math.max(baselineHeight, currentHeight);
    }
  };

  const scheduleState = () => {
    if (stateRaf) return;
    stateRaf = requestAnimationFrame(() => {
      stateRaf = 0;
      syncState();
    });
  };

  document.addEventListener('focusin', (event) => {
    if (!isMobile() || !isPersonalizationTextField(event.target)) return;

    const currentHeight = viewportHeight();
    if (currentHeight) baselineHeight = Math.max(baselineHeight, currentHeight);

    focusGraceUntil = performance.now() + 1000;
    setSuppressed(true);
    window.setTimeout(scheduleState, 1050);
  }, true);

  document.addEventListener('focusout', () => {
    window.setTimeout(() => {
      if (!isPersonalizationTextField(document.activeElement)) focusGraceUntil = 0;
      syncState();
    }, 80);
  }, true);

  vv?.addEventListener('resize', scheduleState, { passive: true });
  vv?.addEventListener('scroll', scheduleState, { passive: true });
  window.addEventListener('resize', scheduleState, { passive: true });
  window.addEventListener('orientationchange', () => {
    window.setTimeout(() => {
      baselineHeight = viewportHeight();
      syncState();
    }, 350);
  }, { passive: true });
  window.addEventListener('pageshow', () => {
    baselineHeight = Math.max(baselineHeight, viewportHeight());
    syncState();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncState, { once: true });
  } else {
    syncState();
  }
})();
